import React from 'react';

export const GridPattern = ({ viewportWidth = 400, viewportHeight = 300, viewportScale = 1 }) => {
  const scaledWidth = viewportWidth * viewportScale;
  const scaledHeight = viewportHeight * viewportScale;
  const gridSize = 20 * viewportScale;
  
  return (
    <defs>
      <pattern id="grid" width={gridSize} height={gridSize} patternUnits="userSpaceOnUse">
        <path d={`M ${gridSize} 0 L 0 0 0 ${gridSize}`} fill="none" stroke="#e0e0e0" strokeWidth="1"/>
      </pattern>
      <rect width="100%" height="100%" fill="url(#grid)" />
    </defs>
  );
};

